import { render, staticRenderFns } from "./ViewFolderItem.vue?vue&type=template&id=365b84e0&scoped=true&"
import script from "./ViewFolderItem.vue?vue&type=script&lang=ts&"
export * from "./ViewFolderItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b84e0",
  null
  
)

export default component.exports